// Auto-generated by scripts/xliff-to-json.cjs -- do not edit by hand

export const translations: Record<string, string> = {
  's17f33773d05f3aed': `Benutzerverwaltung`,
  'sb46734737dd208bb': `Audit-Protokolle`,
  's36e195872312e3b4': `Standortverwaltung`,
  's17669567f329206c': `Standort erstellen`,
  's49730f3d5751a433': `Wird geladen...`,
  's3741f519c32ac391': `Neu`,
  's417b90913e05bc17': `Vorschau`,
  'sffe2914d4b7c91ee': `Frühzugang`,
  's3d64ea063be4c9f2': `Einheitliches Auditing`,
  's596a144afb429d94': `Weitere Produkte`,
  's6d8c02aee480af7a': `Menü`,
  's6abb1cd87fe0114e': `Startseite`,
  's5e8250fb85d64c23': `Schließen`,
  's691d6163aaabb69b': `Benutzerprofil`,
  's352719d86112de9a': `Hilfe`,
  'admin': `Verwaltung`,
  'h88d78370fa007ca9': `Identitäts- und Authentifizierungsanbieter`,
  'sitemenu.dashboard': `Dashboard`,
  'sitemenu.dashboard.dynamicdashboard': `Dashboard (Vorschau)`,
  'sitemenu.assets': `Assets`,
  'sitemenu.smartrules': `Intelligente Regeln`,
  'sitemenu.discovery': `Erkennung`,
  'sitemenu.discovery.newdiscoveryscan': `Neuen Erkennungsscan ausführen`,
  'sitemenu.discovery.activeandcompletedscans': `Aktive/Abgeschlossene Scans`,
  'sitemenu.discovery.scheduledscans': `Geplante Scans`,
  'sitemenu.discovery.discoveryscanners': `Erkennungsscanner`,
  'sitemenu.managedsystems': `Verwaltete Systeme`,
  'sitemenu.managedaccounts': `Verwaltete Konten`,
  'sitemenu.passwordsafe': `Password Safe`,
  'sitemenu.passwordsafe.accounts': `Konten`,
  'sitemenu.passwordsafe.approvals': `Genehmigungen`,
  'sitemenu.passwordsafe.activesessions': `Aktive Sitzungen`,
  'sitemenu.passwordsafe.completedsessions': `Abgeschlossene Sitzungen`,
  'sitemenu.passwordsafe.administratorsessions': `Admin-Sitzungen`,
  'sitemenu.analyticsandreportingtrident': `Analytik und Berichterstellung`,
  'sitemenu.analyticsandreporting.viewallreports': `Alle Berichte anzeigen`,
  'sitemenu.teampasswords': `Secrets Safe`,
  'sitemenu.analytics': `Analytik und Berichterstellung`,
  'sitemenu.configuration': `Konfiguration`,
  'sitemenu.about': `Über`,
  'insights.menu.dashboard': `Dashboard`,
  'insights.menu.identitiesPrivileges': `Identitäten und Berechtigungen`,
  'insights.menu.identities': `Identitäten`,
  'insights.menu.accounts': `Konten`,
  'insights.menu.entitlements': `Berechtigungen`,
  'insights.menu.secretsSecurity': `Geheimnissicherheit`,
  'insights.menu.secrets': `Geheimnisse`,
  'insights.menu.secretsInventory': `Geheimnissinventar`,
  'insights.menu.aiSecurity': `KI-Sicherheit`,
  'insights.menu.aiAgents': `KI-Agenten`,
  'insights.menu.agentInventory': `Agenteninventar`,
  'insights.menu.aiThreatDetection': `Bedrohungserkennung`,
  'insights.menu.aiThreatPolicy': `Bedrohungsrichtlinie`,
  'insights.menu.insights': `Insights`,
  'insights.menu.detections': `Erkennungen`,
  'insights.menu.recommendations': `Empfehlungen`,
  'insights.menu.exclusionRules': `Ausschlussregeln`,
  'insights.menu.reporting': `Berichterstellung`,
  'insights.menu.integrationsConnections': `Integrationen und Verbindungen`,
  'insights.menu.integrations': `Integrationen`,
  'insights.menu.connectors': `Konnektoren`,
  'pmc.explore': `Erkunden`,
  'pmc.audit': `Audit`,
  'pmc.settings': `Einstellungen`,
  'home': `Startseite`,
  'policies': `Richtlinien`,
  'computers': `Computer`,
  'computer-groups': `Computergruppen`,
  'jit-access-management': `JIT-Zugriffsverwaltung`,
  'analytics': `Analytik`,
  'auditing': `Auditing`,
  'management-rules': `Verwaltungsregeln`,
  'configuration': `Konfiguration`,
  'user-management': `Benutzerverwaltung`,
  'status': `Status`,
  'downloads': `Konsolen und Downloads`,
  'my_account': `Mein Konto`,
  'sd': `Konfiguration`,
  'jump': `Asset Management`,
  'vault': `Tresor`,
  'rep_console': `Konsoleneinstellungen`,
  'users': `Benutzer und Sicherheit`,
  'reporting': `Berichte`,
  'public_site': `Öffentliche Portale`,
  'dashboard': `Dashboards`,
  'localization': `Lokalisierung`,
  'management': `Verwaltung`,
  'appliance': `Appliance`,
  'login.status.index': `Informationen`,
  'login.status_representatives.index': `Vertreter`,
  'login.downloads.rep.index': `Rep Console`,
  'login.downloads.drivers.index': `Treiber`,
  'login.my_account.profile.index': `Profil`,
  'login.my_account.security.index': `Sicherheit`,
  'login.sd_general.index': `Optionen`,
  'login.issue.index': `Probleme`,
  'login.team.index': `Supportteams`,
  'login.skill.index': `Fähigkeiten`,
  'login.callback_button.index': `Support-Schaltflächen`,
  'login.custom_fields.index': `Benutzerdefinierte Felder`,
  'login.ms_teams.index': `MS Teams`,
  'login.mcp_config.index': `MCP-Server`,
  'login.pinned_clients.index': `Jump Clients`,
  'login.shared_jump_groups.index': `Asset Groups`,
  'login.jump_policies.index': `Asset Policies`,
  'login.jump_item_roles.index': `Asset Roles`,
  'login.push_agent.index': `Gateway`,
  'login.jump_item.index': `Assets`,
  'login.endpoint_automation.index': `Endpunktautomatisierung`,
  'login.vault_account.index': `Konten`,
  'login.vault_account_group.index': `Kontogruppen`,
  'login.account_policy.index': `Kontorichtlinien`,
  'login.vault_endpoint.index': `Endpunkte`,
  'login.vault_domain.index': `Domänen`,
  'login.discovery.index': `Erkennung`,
  'login.vault_options.index': `Optionen`,
  'login.vault_password_safe_connection.index': `Verbindungen`,
  'login.rep_profile.index': `Rep Console-Einstellungen`,
  'login.custom_links.index': `Benutzerdefinierte Links`,
  'login.canned_message.index': `Vordefinierte Nachrichten`,
  'login.canned_script.index': `Vordefinierte Skripte`,
  'login.special_action.index': `Spezialaktionen`,
  'login.user.index': `Benutzer`,
  'login.rep_invite.index': `Vertretereinladung`,
  'login.security_providers.index': `Sicherheitsanbieter`,
  'login.session_policy.index': `Sitzungsrichtlinien`,
  'login.group_policy.index': `Gruppenrichtlinien`,
  'login.kerberos_keytab.index': `Kerberos Keytab`,
  'login.licensing.index': `Lizenzierung`,
  'login.session_report.index': `Support`,
  'login.license_reporting.index': `Lizenzierung`,
  'login.vault_reporting.index': `Tresor`,
  'login.compliance.index': `Compliance`,
  'login.jump_item_reporting.index': `Asset`,
  'login.duplicate_pinned_clients_reporting.index': `Doppelte Jump Clients`,
  'login.syslog_reporting.index': `Syslog`,
  'login.public_site.index': `Öffentliche Websites`,
  'login.business_hours.index': `Zeitplan`,
  'login.html_template.index': `HTML-Vorlagen`,
  'login.customer_notice.index': `Kundenhinweise`,
  'login.file_store.index': `Dateispeicher`,
  'login.ios_profile.index': `iOS-Konfiguration`,
  'login.exit_survey.index': `Abschlussumfragen`,
  'login.sd_client.index': `Support-Client`,
  'login.dashboard.index': `Dashboards`,
  'login.dashboard.getNetworkRestrictions': `Netzwerkeinschränkungen`,
  'login.nls.real_time_chat.index': `Echtzeit-Chat`,
  'login.settings.index': `Software`,
  'login.security_settings.index': `Sicherheit`,
  'login.site_settings.index': `Standortkonfiguration`,
  'login.email_settings.index': `E-Mail-Konfiguration`,
  'login.outbound_event.index': `Ausgehende Ereignisse`,
  'login.api_account.index': `API-Konfiguration`,
  'login.support_settings.index': `Support`,
  'login.appliance.index': `Appliance`,
  'entitle.menu.requests': `Anfragen`,
  'entitle.menu.identityGraph': `Berechtigungen`,
  'entitle.menu.workflows': `Genehmigungsabläufe`,
  'entitle.menu.integrations': `Integrationen`,
  'entitle.menu.bundles': `Pakete`,
  'entitle.menu.policies': `Grundrechte-Richtlinien`,
  'entitle.menu.tasks': `Aufgaben`,
  'entitle.menu.profile': `Meine Einstellungen`,
  'entitle.menu.accessReview': `Übersicht`,
  'entitle.menu.requestsLog': `Anfragenverlauf`,
  'entitle.menu.auditLogs': `Audit-Protokolle`,
  'entitle.menu.settings': `Organisationseinstellungen`,
  'entitle.menu.users': `Benutzer`,
  'epml.menu.explore': `Erkunden`,
  'epml.menu.audit': `Audit`,
  'epml.menu.settings': `Einstellungen`,
  'epml.menu.policy': `Richtlinie`,
  'epml.menu.endpoints': `Endpunktverwaltung`,
  'epml.menu.installers': `Installationsprogramme`,
  'epml.menu.unifiedSearch': `Einheitliche Suche`,
  'epml.menu.events': `Ereignisse`,
  'epml.menu.consoleAudit': `Konsolen-Audit`,
  'epml.menu.searchAndReplay': `Suche und Wiedergabe`,
  'epml.menu.consoleAccess': `Konsolenzugriff`,
  'epml.menu.epmlSettings': `EPML-Einstellungen`,
  'epml.menu.roles': `Rollen`,
  'epml.menu.siemConnections': `SIEM-Verbindungen`,
  'epml.menu.directoryServices': `Verzeichnisdienste`,
  'epml.menu.linuxHostAuth': `Linux-Host-Authentifizierung`,
  'menu-phantom-labs': `Phantom Labs`,
  'ai-coworkers.menu.dashboards': `Dashboard`,
  'ai-coworkers.menu.inventory': `Sichtbarkeit`,
  'ai-coworkers.menu.inventory.agents': `KI-Agenten`,
  'ai-coworkers.menu.inventory.mcp-servers': `MCP-Server`,
  'ai-coworkers.menu.inventory.model-endpoints': `LLM-Endpunkte`,
  'ai-coworkers.menu.inventory.agent-skills': `Agentenfähigkeiten`,
  'ai-coworkers.menu.inventory.endpoints': `Endpunkte`,
  'ai-coworkers.menu.intelligence': `Intelligenz`,
  'ai-coworkers.menu.agents.events': `Ereignisse`,
  'ai-coworkers.menu.intelligence.coding-sessions': `KI-Sitzungen`,
  'ai-coworkers.menu.control': `Schutz`,
  'ai-coworkers.menu.control.policies': `Richtlinien`,
  'ai-coworkers.menu.control.exceptions': `Ausnahmeanfragen`,
  'ai-coworkers.menu.control.yara-rules': `YARA-Regeln`,
  'ai-coworkers.menu.settings': `Einstellungen`,
  'ai-coworkers.menu.settings.connectors': `Konnektoren`,
  'ai-coworkers.menu.settings.license': `Lizenz & Nutzung`,
  'ai-coworkers.menu.settings.administration': `Verwaltung`,
  'ai-coworkers.menu.agents.deployment': `Bereitstellung`,
  'ai-coworkers.menu.settings.update-strategy': `Update-Strategie`,
  'sa91c1893f06e9a91': `SCIM-Token`,
  'sb5cd73af5ec790f6': `Workload-Identitäten`,
  's29c1fa87a0c0ee4c': `Verzeichnisauthentifizierung`,
  's177fa3e0b2ef5171': `IP-Zulassungsliste`,
  's4c9351ce0cc28196': `Produktnavigation`,
  's76902262e33e63b5': `Seitenleistennavigation umschalten`,
  's714ea1e6436002a2': `Navigation angeheftet halten`,
  's416434bef0c17abc': `Das Menü konnte nicht geladen werden. Schließen Sie es und öffnen Sie es erneut, um es noch einmal zu versuchen.`,
  'admin.menu.users': `Benutzerverwaltung`,
  'admin.menu.identity-providers': `Identitäts- und Authentifizierungsanbieter`,
  'admin.menu.directory-auth': `Verzeichnisauthentifizierung`,
  'admin.menu.workload-identities': `Workload-Identitäten`,
  'admin.menu.scim-tokens': `SCIM-Token`,
  'admin.menu.user-groups': `Benutzergruppen`,
  'admin.menu.roles': `Rollen`,
  'admin.menu.organization-settings': `Organisationseinstellungen`,
  'admin.menu.ip-allowlist': `IP-Zulassungsliste`,
  'admin.menu.audit': `Audit-Protokolle`,
  'admin.menu.site-admin': `Standortverwaltung`,
  'admin.menu.site-admin.create': `Standort erstellen`,
  'siteSelectorLabel': `Site`,
  'siteSelectorSearchPlaceholder': `Sites suchen`,
  'siteSelectorNoSitesFound': `Keine Sites gefunden`,
  'siteSelectorDataResidency': `Datenresidenz`,
  'breadcrumbNavLabel': `Navigationspfad`,
  'breadcrumbOverflowLabel': `Weitere Navigationselemente anzeigen`,
};
